import React from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, Text, xcss } from '@atlaskit/primitives';
import { LinkButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';

type HTV2NthUserLearningCardProps = {
	title: MessageDescriptor;
	description: MessageDescriptor;
	cta: MessageDescriptor;
	link: string;
	onboardingPeriodDay: number;
};

const contentContainerStyles = xcss({
	paddingTop: 'space.200',
	paddingBottom: 'space.200',
	paddingLeft: 'space.200',
	paddingRight: 'space.200',
	height: '100%',
});

const cardStyles = xcss({
	border: `${token('border.width')} solid ${token('color.border')}`,
	borderRadius: 'radius.large',
	background: token('elevation.surface'),
});

export const HTV2NthUserLearningOpportunityCard = ({
	title,
	description,
	cta,
	link,
	onboardingPeriodDay,
}: HTV2NthUserLearningCardProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'homeOnboardingTakeoverNthUserlearningOpportunityCta',
				attributes: {
					onboardingPeriodDay,
					learningOpportunity: title.defaultMessage,
				},
				source: 'onboarding',
			},
		}).fire();
	};

	return (
		<Flex direction="column" xcss={cardStyles}>
			<Flex
				xcss={contentContainerStyles}
				direction="column"
				gap="space.100"
				justifyContent="space-between"
			>
				<Heading size="xsmall">
					<FormattedMessage {...title} />
				</Heading>
				<Text>
					<FormattedMessage {...description} />
				</Text>
				<Flex justifyContent="end">
					<LinkButton appearance="subtle" onClick={handleClick} href={link} target="_blank">
						<FormattedMessage {...cta} />
					</LinkButton>
				</Flex>
			</Flex>
		</Flex>
	);
};
